var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 299.021 299.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1328af",
    d: "M292.866 254.432a6.156 6.156 0 01-5.5-3.399c-.354-.684-28.541-52.949-146.169-54.727v51.977a6.146 6.146 0 01-3.432 5.513 6.157 6.157 0 01-6.461-.63L2.417 154.392A6.154 6.154 0 010 149.516c0-1.919.898-3.72 2.417-4.888l128.893-98.77a6.164 6.164 0 016.461-.639 6.14 6.14 0 013.432 5.509v54.776c3.111-.198 7.164-.37 11.947-.37 43.861 0 145.871 13.952 145.871 143.136a6.15 6.15 0 01-4.75 5.993 5.552 5.552 0 01-1.405.169z",
    "data-original": "#000000",
    transform: "matrix(-1 0 0 1 299.021 0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.a8fbacb97fcd1fc1ab5ef306708fc64a.svg";
export { ForwardRef as ReactComponent };